var r = /* @__PURE__ */ ((o) => (o[o.Year = 0] = "Year", o[o.Month = 1] = "Month", o[o.Day = 2] = "Day", o[o.Hour = 3] = "Hour", o[o.Minute = 4] = "Minute", o[o.Second = 5] = "Second", o))(r || {});
const u = 864e5;
export {
  r as DateUnit,
  u as MILLISECONDS_IN_DAY
};
//# sourceMappingURL=date.js.map
